// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ava2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/chat/typing.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/chat/send.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatWidget{
    position: relative;
    min-width: 250px;
    width: 100%;
}

.chatWidget_wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px 21px;
    background-color: #fff;
    border-radius: 30px;
    box-shadow: 0px 0px 15px #0003;
}

.chatWidget--opened{
}

.chatWidget_header{
    display: flex;
    justify-content: space-between;
    align-items: center;

    border: none;
    width: 100%;
    height: 39px;
    background: transparent;
    border-radius: 30px;
}

.chatWidget_title{
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    color: #343434;;
}

.chatWidget_arrow{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
}

.chatWidget_drop{
    display: grid;
    grid-template-rows: 0fr;
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;

    border: none;
    width: 100%;

    font-weight: 400;
    font-size: 10px;
    line-height: 150%;
    color: #B8BCCA;
}

.chatWidget--opened .chatWidget_drop{
    grid-template-rows: 1fr;
}

.chatWidget_drop_content{
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.chatWidget_scroll{
    height: 300px;
    overflow: scroll;
}

.chatWidget_message{
    display: flex;
    align-items: flex-start;
    gap: 14px;

    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #08080A;
}

.chatWidget_message_text{
    padding: 10px 15px;
    width: 100%;
    min-height: 19px;

    background: #E0E0E0;
    border-radius: 21.7919px 21.7919px 21.7919px 0px;
}

.chatWidget_message--mine{
    margin-left: 47px;
    margin-right: 14px;
}

.chatWidget_message--mine .chatWidget_message_text{
    background: #E9EAF1;
    border-radius: 24px 24px 0px 24px;
}

.chatWidget_message_avatar{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 39px;
    height: 39px;
    border-radius: 100%;

    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.chatWidget_message--mine .chatWidget_message_avatar{
    display: none;
}

.chatWidget_typing{
    display: flex;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #CAC4D0;
    margin-bottom: 22px;
}

.chatWidget_typing_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.chatWidget_typing_text{

}

.chatWidget_messages{
    display: flex;
    flex-direction: column;
    gap: 21px;
    margin-bottom: 22px;
}

.chatWidget_inputs{
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
}

.chatWidget_attach{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    width: 37px;
    height: 37px;
    border-radius: 100%;
    border: 1px solid #EEF0F7;

    flex-shrink: 0;
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
}

.chatWidget_input{
    display: flex;
    background: #F6F6F9;
    border-radius: 23px;
    padding: 7px;
    gap: 7px;
    width: 100%;
}

.chatWidget_input_message{
    width: 100%;
    resize: none;
    border: none;
    background-color: transparent;

    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #08080A;
    font-family: inherit;
    padding: 4px;
    height: 29px;
}

.chatWidget_input_send{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    width: 29px;
    height: 29px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}



`, "",{"version":3,"sources":["webpack://./src/components/chat/Chat.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yDAAoD;IACpD,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,+DAA+D;IAC/D,gBAAgB;;IAEhB,YAAY;IACZ,WAAW;;IAEX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;;IAET,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;;IAEhB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yDAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yDAA6C;IAC7C,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;;IAEzB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;;IAE7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yDAAmD;IACnD,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC","sourcesContent":[".chatWidget{\n    position: relative;\n    min-width: 250px;\n    width: 100%;\n}\n\n.chatWidget_wrap{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 12px 21px;\n    background-color: #fff;\n    border-radius: 30px;\n    box-shadow: 0px 0px 15px #0003;\n}\n\n.chatWidget--opened{\n}\n\n.chatWidget_header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    border: none;\n    width: 100%;\n    height: 39px;\n    background: transparent;\n    border-radius: 30px;\n}\n\n.chatWidget_title{\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 28px;\n    color: #343434;;\n}\n\n.chatWidget_arrow{\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    flex-shrink: 0;\n\n    background-image: url('../../assets/open-arrow.svg');\n    background-size: 8px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.chatWidget_drop{\n    display: grid;\n    grid-template-rows: 0fr;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n\n    border: none;\n    width: 100%;\n\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 150%;\n    color: #B8BCCA;\n}\n\n.chatWidget--opened .chatWidget_drop{\n    grid-template-rows: 1fr;\n}\n\n.chatWidget_drop_content{\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n}\n\n.chatWidget_scroll{\n    height: 300px;\n    overflow: scroll;\n}\n\n.chatWidget_message{\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    color: #08080A;\n}\n\n.chatWidget_message_text{\n    padding: 10px 15px;\n    width: 100%;\n    min-height: 19px;\n\n    background: #E0E0E0;\n    border-radius: 21.7919px 21.7919px 21.7919px 0px;\n}\n\n.chatWidget_message--mine{\n    margin-left: 47px;\n    margin-right: 14px;\n}\n\n.chatWidget_message--mine .chatWidget_message_text{\n    background: #E9EAF1;\n    border-radius: 24px 24px 0px 24px;\n}\n\n.chatWidget_message_avatar{\n    background-image: url('../../assets/ava2.png');\n    width: 39px;\n    height: 39px;\n    border-radius: 100%;\n\n    flex-shrink: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.chatWidget_message--mine .chatWidget_message_avatar{\n    display: none;\n}\n\n.chatWidget_typing{\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #CAC4D0;\n    margin-bottom: 22px;\n}\n\n.chatWidget_typing_icon{\n    background-image: url('../../assets/chat/typing.svg');\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.chatWidget_typing_text{\n\n}\n\n.chatWidget_messages{\n    display: flex;\n    flex-direction: column;\n    gap: 21px;\n    margin-bottom: 22px;\n}\n\n.chatWidget_inputs{\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    width: 100%;\n}\n\n.chatWidget_attach{\n    background-image: url('../../assets/add.svg');\n    width: 37px;\n    height: 37px;\n    border-radius: 100%;\n    border: 1px solid #EEF0F7;\n\n    flex-shrink: 0;\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.chatWidget_input{\n    display: flex;\n    background: #F6F6F9;\n    border-radius: 23px;\n    padding: 7px;\n    gap: 7px;\n    width: 100%;\n}\n\n.chatWidget_input_message{\n    width: 100%;\n    resize: none;\n    border: none;\n    background-color: transparent;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    color: #08080A;\n    font-family: inherit;\n    padding: 4px;\n    height: 29px;\n}\n\n.chatWidget_input_send{\n    background-image: url('../../assets/chat/send.svg');\n    width: 29px;\n    height: 29px;\n    flex-shrink: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
